export const constants = {
	selector: {
		datatable: 'data-datatable',
		endpoint: 'data-endpoint',
	},
	attributes: {
		readMoreText: 'data-read-more-text',
		readLessText: 'data-read-less-text',
	},
}
